<template>
  <div class="w-96 relative leading-tight">
    <input v-model="placeholder" type="text" class="h-12 w-full border-0 bg-transparent pr-4 focus:ring-0" placeholder="New placeholder..." ref="input" @keydown="keydown">

    <div class="absolute right-0 top-0 h-full w-12 p-0.5 flex">
      <button class="bg-gray-800 cursor-pointer hover:brightness-110 rounded-lg flex justify-center items-center basis-full text-primary" @click="save">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
          <path d="M12 1.5a.75.75 0 01.75.75V7.5h-1.5V2.25A.75.75 0 0112 1.5zM11.25 7.5v5.69l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V7.5h3.75a3 3 0 013 3v9a3 3 0 01-3 3h-9a3 3 0 01-3-3v-9a3 3 0 013-3h3.75z" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: ['value'],
  data() {
    return {
      placeholder: this.value,
    }
  },
  mounted() {
    this.$refs.input.focus()
  },
  methods: {
    keydown({ key }) {
      if (key === "Enter") this.save()
    },
    save() {
      this.$emit("set-value", this.placeholder)
    },
  },
}

</script>
